module.exports = __webpack_public_path__ + "static/media/loader.d9c389b8.svg";